import React, { Fragment } from 'react';
import { styled } from '@mui/material';
import { addRequestToCachePartnerOverview } from 'FeatureModules/Partner/utils/partner.utils';
import { IBasePartnerCompany, IPartnerRequest } from 'FeatureModules/Partner/types/partner.types';
import { ApolloCache } from '@apollo/client';
import PartnerDocumentList from './PartnerDocumentList';
import { IBaseDocument } from 'FeatureModules/Document/types/document.types';
import useDialog from 'hooks/useDialog';
import { useNavigate } from 'react-router-dom';

export const RequestIcon = styled('img')(() => ({
  width: 18,
}));

interface IProps {
  totalDocuments?: number;
  documents: IBaseDocument[];
  partner: IBasePartnerCompany;
}

const PartnerDocumentOverview: React.FC<IProps> = ({ documents, partner, totalDocuments }) => {
  const navigate = useNavigate();
  const { openDialog } = useDialog();

  const handleCreateRequest = () => {
    openDialog({
      type: 'PARTNER_REQUEST',
      props: {
        requestedToCompany: partner,
        onUpdateCache: (cache: ApolloCache<unknown>, request: IPartnerRequest) =>
          addRequestToCachePartnerOverview(cache, request, partner.id),
      },
    });
  };

  const handleAllDocumentsClick = () => {
    navigate(`/partners/${partner.id}/documents`);
  };

  return (
    <Fragment>
      {documents.length > 0 && (
        <PartnerDocumentList
          totalItems={totalDocuments}
          onCreateClick={handleCreateRequest}
          onAllDocumentsClick={handleAllDocumentsClick}
          documents={documents}
        />
      )}
    </Fragment>
  );
};

export default PartnerDocumentOverview;
